var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-detail"},[_c('loader'),_c('transition',{attrs:{"name":"fade-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadFinished),expression:"loadFinished"}],staticClass:"rotate"},[_vm._v("Swipe to Rotate")])]),_c('scene',{attrs:{"model":_vm.currentModel}}),_c('div',{staticClass:"main-icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }